import axios, { AxiosResponse } from "axios";
import { Assignee, InternalUser } from "../../../types/domain";

export const UNASSIGN_VALUE = -1;

interface InternalUsersParam{
  IsActive?: boolean
}

interface InternalUsersByRolesParam extends InternalUsersParam{
  roleCodes : string[]
}

export const getInternalUsers = (param: InternalUsersParam): Promise<Assignee[]> =>
  axios.post("users/getInternal", param)
    .then((res: AxiosResponse<InternalUser[]>) =>
    res.data
      .map((item) => ({
        displayName: item.displayName,
        id: item.userId,
      }))
      .sort((a, b) => (a.displayName > b.displayName ? 1 : -1))
  );

export const getInternalUsersByRoles = (param: InternalUsersByRolesParam): Promise<Assignee[]> =>
  axios.post("users/getInternalByRoles", param)
    .then((res: AxiosResponse<InternalUser[]>) =>
      res.data
        .map((item) => ({
          displayName: item.displayName,
          id: item.userId,
        }))
        .sort((a, b) => (a.displayName > b.displayName ? 1 : -1))
  );